import React, {useState, useRef} from "react";
import "../App.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const emailInputRef = useRef(null);
  const passwordRef = useRef(null);

  const onSubmit = () => {
    const isValidEmail = /.+@.+\..+/.test(email);

    let isValid = true;

    if (!email.trim() || !isValidEmail) {
      setEmailError("Please enter a valid email address");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!password) {
      setPasswordError("Password is required");
      isValid = false;
    } else {
      setPasswordError("");
    }

    if (!isValid) {
      if (emailError && emailInputRef.current) emailInputRef.current.focus();
      else if (passwordError && passwordRef.current) passwordRef.current.focus();
      return;
    }

    setSubmitting(true);
    setShowBanner(false);
    setTimeout(() => {
      setSubmitting(false);
      setShowBanner(true);
    }, 30000);
  };

  return (
    <div className="App">
      <div className="fullscreen-section-content">
        <div className="row leadscrush-layout">
          <div className="col-md-4 form-column">
            <div className="register-rightSide">
              <h3 className="form-title large-title">Welcome back!</h3>
              <div className="form-subtitle">Please login to your account</div>
              <div className="register-form">
                <div className="form-group field">
                  <input
                    id="email"
                    ref={emailInputRef}
                    className="input floating"
                    type="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      if (emailError) setEmailError("");
                    }}
                    placeholder=" "
                    autoComplete="email"
                    disabled={submitting}
                  />
                  <label htmlFor="email">Email address</label>
                  {emailError && <div style={{color: "#dc3545", fontSize: "12px", marginTop: "4px"}}>{emailError}</div>}
                </div>

                <div className="form-group field">
                  <input
                    id="password"
                    ref={passwordRef}
                    className="input floating with-toggle"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      if (passwordError) setPasswordError("");
                    }}
                    placeholder=" "
                    autoComplete="current-password"
                    disabled={submitting}
                  />
                  <label htmlFor="password">Password</label>
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="#637381" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <circle cx="12" cy="12" r="3" stroke="#637381" strokeWidth="2"/>
                      </svg>
                    ):( <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 3l18 18" stroke="#637381" strokeWidth="2" strokeLinecap="round"/>
                      <path d="M10.58 10.58A3 3 0 0012 15a3 3 0 002.42-4.42M21 12s-3.5 6-9 6-9-6-9-6 3.5-6 9-6 9 6 9 6z" stroke="#637381" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    )}
                  </button>
                  {passwordError && <div style={{color: "#dc3545", fontSize: "12px", marginTop: "4px"}}>{passwordError}</div>}
                </div>
                <div className="form-aux">
                  <a className="forgot-link" href="#">
                    Forgot password?
                  </a>
                </div>

                <button type="button" className="btn-primary" onClick={onSubmit} disabled={submitting}>
                  {submitting ? (
                    <>
                      <div className="spinner"></div>
                      Login
                    </>
                  ) : (
                    "Login"
                  )}
                </button>

                <div style={{marginTop: "20px", textAlign: "left", fontSize: "14px", fontweight: "300", letterSpacing: "0.01em", color: "#212b36"}}>
                  <div>
                    New user? <a href="#">Create an account</a>
                  </div>
                </div>
                {showBanner && (
                  <div className="maintenance-banner" role="status">
                    It seems there’s a technical issue. Please contact us at <a href="#">Support@leadscrush.com</a> for assistance.
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Column: Hero panel */}
          <div className="col-md-8 hero-column">
            <div className="hero-panel">
              <img className="hero-image" src={`${process.env.PUBLIC_URL || ""}/assets/illustration_dashboard.png`} alt="LeadsCrush dashboard illustration" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
